<template>
    <div class="regular fullBg">
        <div class="rightWeekData">
            <div class="headP">
                <p class="img"><img
                    :src="infoMesData?infoMesData.avatar:require('@/assets/img/updateImg/playerHead.png')" alt="">
                </p>
                <p class="name">
                    <span class="zh">{{ infoMesData ? infoMesData.name : '' }}</span>
                    <span class="en">{{ infoMesData ? infoMesData.nameEn : '' }}</span>
                </p>
                <p class="position">
                    <!--                    <i><img :src="require('@/assets/img/playerImg/'+$route.params.position+'.svg')" alt=""></i>-->
                </p>
                <p class="playerMsg" v-if="barDate">
                    <span class="star">{{ barDate }}</span>
                </p>
            </div>
            <div id="networkDiagram" class="message" style="height: 12vw;width:35vw;"></div>
            <div class="barTit">
                <template v-for="item in colorObj">
                   <span class="titCol"
                         :style="{background: 'linear-gradient(180deg,'+item.start+' 0%, '+item.end+' 100%)'}"></span>
                    <span class="titLab">{{ item.name }}</span>
                </template>
            </div>
            <div id="weekBar" style="height: calc(100% - 11vw);  width: 90%;clear: both"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "assessmentReportDetail",
    props: {
        // trainingReportId: String
    },
    data() {
        return {
            trainingReportId: this.$route.params.id,//球员id
            // trainingReportId: '60f5098424df485358d8f740',//球员id
            // seasonId: this.$route.params.seasonId,//赛季id
            infoMesData: null,//初始化的数据
            playersReportList: null,//球员获取评估项

            workDiagram: {},//雷达图各项数据
            dateBar: {},//柱状图各项数据
            barLin: 55,//柱状图显示个数
            barDate: '',//柱状图时间

            timeInfo: null,//定时器--首次加载
            timer: null,//定时器--间隔加载

            colorObj: [
                {
                    name: '技术 Personality',
                    start: "#2979FF",
                    end: "#42A5F5",
                },
                {
                    name: '战术 Technical',
                    start: "#34C955",
                    end: "#85C934",
                }, {
                    name: '性格 Personality',
                    start: "#FFB23E",
                    end: "#FFD02B",
                }
            ],
        }
    },
    mounted() {
        this.infoFn();
    },
    watch: {},
    methods: {
        //初始化数据
        infoFn() {
            let data = {
                id: this.trainingReportId,//球员id
                info: 'personal'
                // seasonId:this.seasonId
            }

            this.$server.getUserMsg(data).then((res) => {
                this.infoMesData = res.data;

                data = {
                    playerId: this.trainingReportId,//球员id
                    start: new Date().getFullYear()+'/01/01',
                    end: this.$global.formatDate(new Date(), 'yyyy/MM/dd', true),
                }
                this.$server.getPlayersReportWeekAll(data).then((res) => {
                    this.weekBarData(res.data);
                });
                this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是" + this.infoMesData.name + this.$global.randomFn(this.$aiJson.playVoice.reportDetail)), true, false)
            })
        },
        //网络图
        networkDiagram(data) {
            data = JSON.parse(data);
            let indicatorArr = [
                {name: '技术', nameEn: 'Technical', max: 4},
                {name: '战术', nameEn: 'Tactical', max: 4},
                {name: '性格', nameEn: 'Personality', max: 4},
                // {name: '智商', max: 100},
                // {name: '身体', max: 100},
                // {name: '速度', max: 100}
            ], seriesVal = [data.technical, //技术能力
                data.tactical, //战术能力
                data.personality,//性格
                // data.iq,//智商
                // data.body,//身体
                // data.speed,//速度
            ]
            let myChart = this.$echarts.init(document.getElementById('networkDiagram'));
            myChart.setOption({
                title: {text: null}, // 隐藏图表标题
                legend: {enabled: false}, // 隐藏图例
                tooltip: {
                    trigger: 'axis'
                },
                calculable: true,
                radar: [
                    {
                        splitNumber: 4, // 雷达图圈数设置
                        nameGap: 10, // 图中工艺等字距离图的距离
                        center: ['50%', '60%'], // 图的位置
                        shape: 'circle',
                        name: {
                            show: true, // 是否显示工艺等文字
                            formatter: (params, value) => {
                                let num;
                                let name;
                                for (let i = 0; i < indicatorArr.length; i++) {
                                    if (indicatorArr[i].name == params) {
                                        num = seriesVal[i];
                                        if (this.$store.state.language == 'en') {
                                            name = indicatorArr[i].nameEn
                                        } else {
                                            name = indicatorArr[i].name
                                        }
                                    }
                                }
                                let html = [
                                    '{label|' + name + ' ' + '}{num|' + ' ' + num + '}'
                                ]
                                return html;
                            }, // 工艺等文字的显示形式
                            rich: {
                                label: {
                                    color: '#979797',// 工艺等文字颜色
                                    fontSize: 18
                                },
                                num: {
                                    color: '#71ABFB',
                                    fontSize: 24,
                                    fontFamily: 'akrobatBold'
                                },
                            },
                        },
                        indicator: indicatorArr,
                        axisLine: {            // 坐标轴线
                            show: true,        // 默认显示，属性show控制显示与否
                            lineStyle: {
                                color: '#383838', // 设置网格的颜色
                            },
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                // color: '#2A2C3B', // 图表背景的颜色
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                    offset: 1,
                                    color: 'rgba(73, 73, 73, 0.54)'
                                },
                                    {
                                        offset: 0.5,
                                        color: 'rgba(51, 51, 51, 0.2)'
                                    },
                                    {
                                        offset: 0,
                                        color: 'rgba(73, 73, 73, 0.54)'
                                    }])
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                width: 1,
                                color: 'rgba(73, 73, 73, 0.54)', // 设置网格的颜色
                            },
                        }
                    }
                ],
                series: [
                    {
                        name: '维度数据',
                        type: 'radar',
                        symbol: "none", // 去掉图表中各个图区域的边框线拐点
                        itemStyle: {
                            normal: {
                                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 1,
                                    color: 'rgba(103, 168, 228, 0.4)'
                                },
                                ]),// 图表中各个图区域的边框线拐点颜色
                                lineStyle: {
                                    color: "#49A8E8" // 图表中各个图区域的边框线颜色
                                },
                                areaStyle: {
                                    type: 'default'
                                }
                            }
                        },
                        data: [
                            {
                                value: seriesVal
                            },
                        ],
                    }
                ]
            });
        },
        //柱状图
        weekBarData(data) {
            if (!data.length) {
                return
            }
            let barWidth = 13;//柱状图默认宽度

            let dateBarArr = data;
            this.dateBar = this.serializationList(dateBarArr[0]);
            console.log(this.dateBar)
            let thisBarDataX = [];//柱状图个数
            for (let i = 0; i < this.barLin; i++) {
                thisBarDataX.push(i)
            }
            this.positionList(this.dateBar.infoData.scale);//问题接口
            // data[data.length].date.split('W')[1]
            // 指定图表的配置项和数据
            let myChart = this.$echarts.init(document.getElementById('weekBar'));
            var labelOption = {
                show: true,
                position: 'top',
                distance: 15,
                align: 'left',
                verticalAlign: 'middle',
                rotate: 90,
                formatter: (ind) => {
                    // console.log(ind);
                    // console.log(this.playersReportList[this.dateBar.lastShowDataQuestion[ind.dataIndex]])
                    // this.playersReportList[this.dateBar.lastShowDataQuestion[ind.dataIndex]]
                    // console.log(this.playersReportList)
                    // console.log(ind.dataIndex)
                    // console.log(this.dateBar.lastShowDataQuestion[ind.dataIndex])
                    let type = this.dateBar.lastShowDataQuestion[ind.dataIndex].split('_')[0];
                    let titleArr = this.playersReportList[type]
                    // console.log(titleArr);
                    if (titleArr && titleArr.child) {
                        for (let i = 0; i < titleArr.child.length; i++) {
                            if (titleArr.child[i].key == this.dateBar.lastShowDataQuestion[ind.dataIndex]) {
                                let title = titleArr.child[i];
                                // console.log(title)
                                return title ? ind.value + " " + title.name : ''
                            }
                        }
                    }

                },
                fontSize: 12,
                color: 'rgba(255,255,255,.4)',
                 rich: {
                     num: {
                         fontSize: 16,
                         color: 'rgba(255,255,255,.8)',
                     }
                 }
            };

            myChart.setOption({
                grid: {
                    x: 40,
                    y: 10,
                    right: 0,
                    top: '20%',
                    bottom: '15%',
                    borderWidth: 1
                },
                //  ------  X轴 ------
                xAxis: {
                    show: false,  // 是否显示
                    nameGap: 15, // 坐标轴名称与轴线之间的距离
                    nameRotate: 0,  // 坐标轴名字旋转
                    axisLine: {       // 坐标轴 轴线
                        show: true,  // 是否显示
                        // ------   线 ---------
                        lineStyle: {
                            color: '#616162',
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisTick: {    // 坐标轴 刻度
                        show: false,  // 是否显示
                    },
                    data: thisBarDataX
                },
                //   ------   y轴  ----------
                yAxis: {
                    show: false,  // 是否显示
                    nameTextStyle: {    // 坐标轴名称样式
                        color: '#fff',
                        padding: [5, 0, 0, 5]  // 坐标轴名称相对位置
                    },
                    nameGap: 15, // 坐标轴名称与轴线之间的距离

                    axisLine: {    // 坐标轴 轴线
                        show: true,  // 是否显示
                        // ----- 线 -------
                        lineStyle: {
                            color: '#616162',
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisTick: {      // 坐标轴的刻度
                        show: true,    // 是否显示
                        inside: true,  // 是否朝内
                        length: 3,      // 长度
                        lineStyle: {
                            color: '#616162',  // 默认取轴线的颜色
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisLabel: {      // 坐标轴的标签
                        show: true,    // 是否显示
                        inside: false,  // 是否朝内
                        rotate: 0,     // 旋转角度
                        margin: 8,     // 刻度标签与轴线之间的距离
                        color: '#fff',  // 默认轴线的颜色
                    },
                    splitLine: {    // gird 区域中的分割线
                        show: true,   // 是否显示
                        lineStyle: {
                            color: '#666',
                            width: 1,
                            type: 'solid'
                        }
                    },
                },
                //  -------   内容数据 -------
                series: [
                    {
                        type: 'bar',      // 类型
                        label: labelOption,
                        itemStyle: {    // 图形的形状
                            normal: {
                                //柱形图圆角，初始化效果
                                barBorderRadius: [3, 3, 0, 0],
                                color: this.barColorFn
                            }
                        },
                        barWidth: barWidth,  // 柱形的宽度
                        barGap: '10%',
                        // barCategoryGap: '20%',  // 柱形的间距

                        data: thisBarDataInfo,
                        markLine: {
                            symbol: ['none', 'none'],//去掉箭头
                            lineStyle: {
                                type: 'dotted',
                                color: 'rgba(207, 212, 217, .36)'
                            },
                            label: {
                                // position: 'insideStartTop'
                            },
                            data: [
                                {type: 'average', name: '平均值'}
                            ]
                        },//平均线
                    }
                ]
            });
            //初始数据
            var thisBarDataInfo = [];//第一次加载
            let indInfo = 0;
            clearInterval(this.timeInfo);
            this.timeInfo = null;
            this.timeInfo = setInterval(() => {
                if (this.dateBar.lastShowData[indInfo]) {//判断当前位置
                    thisBarDataInfo.push(this.dateBar.lastShowData[indInfo]);
                    indInfo++

                    myChart.setOption({
                        series: [
                            {
                                data: thisBarDataInfo
                            }
                        ],
                    });
                } else {
                    clearInterval(this.timeInfo)
                }

            }, 90)
            this.networkDiagram(this.workDiagram);
            //间隔变换数据
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                barWidth == 5 ? barWidth = 13 : barWidth = 5;
                myChart.setOption({
                    series: [
                        {
                            barWidth: barWidth,  // 柱形的宽度
                        }
                    ],
                });
                let barShowTime = null;
                barShowTime = setTimeout(() => {
                    if (dateBarArr.indexOf(this.dateBar.infoData) == (dateBarArr.length - 1)) {
                        this.dateBar = this.serializationList(dateBarArr[0])
                    } else {
                        this.dateBar = this.serializationList(dateBarArr[dateBarArr.indexOf(this.dateBar.infoData) + 1])
                    }
                    this.networkDiagram(this.workDiagram);
                    this.positionList(this.dateBar.infoData.scale);//问题接口
                    let thisBarData = [];
                    let time = null;
                    let ind = 0;
                    time = setInterval(() => {
                        if (this.dateBar.lastShowData[ind]) {
                            thisBarData.push(this.dateBar.lastShowData[ind]);
                            ind++

                            myChart.setOption({
                                series: [
                                    {
                                        itemStyle: {    // 图形的形状
                                            normal: {
                                                // color: '#81B5FF'
                                                //柱形图圆角，初始化效果
                                                barBorderRadius: [2, 2, 0, 0],
                                                color: this.barColorFn
                                            }
                                        },
                                        barWidth: barWidth,  // 柱形的宽度
                                        data: thisBarData
                                    }
                                ],
                            });
                        } else {
                            clearInterval(time)
                        }

                    }, 90)
                }, 1000);
            }, 10000)
        },
        //颜色
        barColorFn(params) {
            let TechnicalInd = (this.dateBar.Technical.length - 1);
            let TacticalInd = TechnicalInd + this.dateBar.Tactical.length;
            let PersonalityInd = TacticalInd + this.dateBar.Personality.length;
            let thisBarData = this.dateBar.thisBarData.length

            for (let i = 0; i < Math.ceil(this.barLin / this.dateBar.thisBarData.length); i++) {
                if (params.dataIndex <= (thisBarData * i + TechnicalInd)) {
                    return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                        offset: 1,
                        color: '#2979FF'
                    },
                        {
                            offset: 0,
                            color: '#42A5F5'
                        }])
                } else if (params.dataIndex > (thisBarData * i + TechnicalInd) && params.dataIndex <= (thisBarData * i + TacticalInd)) {
                    // return '#F3C74E'
                    return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                        offset: 1,
                        color: '#34C955'
                    },
                        {
                            offset: 0,
                            color: '#85C934'
                        }])
                } else if (params.dataIndex > (thisBarData * i + TacticalInd) && params.dataIndex <= (thisBarData * i + PersonalityInd)) {
                    return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                        offset: 1,
                        color: '#FFB23E'
                    },
                        {
                            offset: 0,
                            color: '#FFD02B'
                        }])
                }
            }
        },
        //问题渲染
        positionList(scale) {
            //根据球员位置和大小周获取评估项
            let data = {
                position: this.infoMesData.position,
                scale: scale,//大小周
                language: 'zh'
            }
            this.$server.getPlayersReportList(data).then((res) => {
                this.playersReportList = this.positionScreen(res.data);
            });
        },
        //数据分类
        serializationList(list) {
            let data = JSON.parse(list.item);
            let thisBarData = [];//得分数组
            let thisBarDataQuestion = [];//评估项
            this.barDate = list.date;
            this.workDiagram = list.mean;

            let Personality = [], Technical = [], Tactical = [];//评估分数
            let PersonalityQuestion = [], TechnicalQuestion = [], TacticalQuestion = [];//评估项问题

            for (var key in data) {
                if (key.split('_')[0] == 'Personality') {
                    Personality.push(data[key])
                    PersonalityQuestion.push(key)
                } else if (key.split('_')[0] == 'Technical') {
                    Technical.push(data[key])
                    TechnicalQuestion.push(key)
                } else if (key.split('_')[0] == 'Tactical') {
                    Tactical.push(data[key])
                    TacticalQuestion.push(key)
                }
            }
            //真实数据
            thisBarData = thisBarData.concat(Technical).concat(Tactical).concat(Personality);
            thisBarDataQuestion = thisBarDataQuestion.concat(TechnicalQuestion).concat(TacticalQuestion).concat(PersonalityQuestion);
            //累加柱状图显示数据
            let lastShowData = [];
            let lastShowDataQuestion = [];
            if (thisBarData.length < this.barLin) {//向上取整显示柱状图
                // console.log(this.barLin/thisBarData.length)
                for (let i = 0; i < Math.ceil(this.barLin / thisBarData.length); i++) {
                    lastShowData = lastShowData.concat(thisBarData)
                    lastShowDataQuestion = lastShowDataQuestion.concat(thisBarDataQuestion)
                }
            }
            // console.log(lastShowData)
            // console.log(Technical)
            // console.log(Tactical)
            // console.log(Personality)
            // console.log(thisBarData);
            return {
                thisBarData: thisBarData,//数据
                thisBarDataQuestion: thisBarDataQuestion,//数据对应的评估项
                lastShowData: lastShowData,//显示数据
                lastShowDataQuestion: lastShowDataQuestion,//显示数据对应的评估项
                Personality: Personality,//性格
                Technical: Technical,//技术
                Tactical: Tactical,//战术
                infoData: list,//原始数据
            }
        },
        //问题分类
        positionScreen(data) {
            let map = {}
            for (let i = 0; i < data.length; i++) {
                map[data[i].key] = data[i]
            }
            // console.log(map);
            return map
        }
    },
    destroyed() {
        clearInterval(this.timer);
        clearInterval(this.timeInfo);
    }
}
</script>

<style scoped lang="less">
.fullBg {
    background-image: url("../assets/img/updateImg/bg3.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.rightWeekData {
    width: 75%;
    height: calc(100% - 8vw);
    margin-bottom: 3vw;
    padding: 5vw 8vw 0 5vw;
    box-sizing: border-box;
    float: left;
    position: relative;
    color: #fff;
}

.message {
    position: absolute;
    right: 10%;
    top: 10%;
}

.barTit {
    /*position: absolute;*/
    /*top: 14vw;*/
    /*right: 5vw;*/
    padding-bottom: 1vw;
    margin-right: 1vw;
    padding-top: 3vw;
    font-size: 22px;
    margin-top: 2vw;
    border-top: 1px solid rgba(255, 255, 255, .05);
    float: right;

    span {
        float: left;
    }

    .titCol {
        width: 24px;
        height: 24px;
        display: inline-block;
    }

    .titColXingGe {
        background: #F3C74E;
    }

    .titColJiShu {
        background: #71ABFB;
    }

    .titColZhanShu {
        background: #4BCC6E;
    }

    .titLab {
        font-family: PingFang;
        color: #fff;
        padding-left: .5vw;
        padding-right: 1.5vw;
        margin-top: -8px;
    }
}

.headP {
    font-size: 44px;
    margin-top: 3vw;
    height: 8vw;
    /*line-height: 8vw;*/
    background-size: auto 100%;
    background-repeat: no-repeat;
    position: relative;

    .img {
        float: left;
        width: 7vw;
        height: 7vw;
        overflow: hidden;
        border-radius: 50%;
        background-color: rgba(12, 12, 13, 1);

        img {
            width: 100%;
        }
    }

    .name {
        padding-left: 3vw;
        float: left;
        font-family: PingFangMedium;

        span {
            display: block;
        }

        span.zh {
            font-weight: bolder;
            font-size: 60px;
            background: linear-gradient(180deg, #FFFFFF 0%, #CAC9C9 200%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        span.en {
            font-size: 30px;
            background: linear-gradient(180deg, rgba(255, 255, 255, .6) 0%, rgba(202, 201, 201, .6) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    .position {
        float: left;
        margin-left: 2vw;
        margin-top: 1.5vw;
    }

    .playerMsg {
        color: rgba(255, 255, 255, .8);
        position: absolute;
        right: -7.1vw;
        top: 3vw;
        margin-left: 2vw;
        text-align: left;
        margin-top: 1.5vw;
        font-size: 30px;

        .star {
            font-family: PingFangMedium;
            background-image: url("../assets/img/playerImg/bg2.svg");
            background-size: 100% auto;
            padding-right: 2vw;
            padding-left: 1vw;
            padding-top: .2vw;
            padding-bottom: .2vw;
            width: 13vw;
            display: inline-block;

            img {
                width: 1.5vw;
                height: 1.5vw;
                margin-right: 1vw;
            }
        }
    }
}


</style>
